import {Route} from "react-router-dom";
import PokemonBox from "./PokemonBox";

const FilterDisplay = (props) => {
    return(
        <div className="filter-display">
            <Route exact path="/">
                <h3>{"All Pokemons"}</h3>
                <div className="filter-sub-display">
                    {
                        props.pokemons.map ((pokemon)=>
                            <PokemonBox
                                key = {pokemon.ntnlnum}
                                pokemon = {pokemon}
                            />
                        )
                    }
                </div>
            </Route>
            {
                props.types.map((pokemonType) => 
                    <Route path={`/pokedex/` + pokemonType} key={pokemonType}>
                        <h3 className={pokemonType}>{pokemonType + " Pokemons"}</h3>
                        <div className="filter-sub-display">
                        {
                            pokemonType !== "All" ?
                            props.pokemons.filter((pokemon) => 
                                pokemon.types.findIndex((type) => type === pokemonType) >= 0
                            ).map( (pokemon) =>
                                <PokemonBox
                                    key = {pokemon.ntnlnum}
                                    pokemon = {pokemon}
                                />
                            )
                            :
                            props.pokemons.map ((pokemon)=>
                                <PokemonBox
                                    key = {pokemon.ntnlnum}
                                    pokemon = {pokemon}
                                />
                            )
                        }
                        </div>
                    </Route>
                )
            }
        </div> 
    )
}

export default FilterDisplay
